// open qv on tile click
const openQuickShopModal = (productOrHandle) => {
  const handle =
    typeof productOrHandle === 'string'
      ? productOrHandle
      : productOrHandle?.handle;

  if (!handle) {
    console.error('Missing product handle', productOrHandle);
    return;
  }

  if (typeof window.loadQuickview !== 'function') {
    console.error('window.loadQuickview is not available');
    return;
  }

  window.loadQuickview({ url: `/products/${handle}` });
};

const getTolstoyProductHandle = (tile) => {
  if (!tile) return null;

  const handleElement = tile.querySelector('[data-product-handle]');
  return handleElement?.getAttribute('data-product-handle') || null;
};

let tolstoyTileOverrideBound = false;
const initTolstoyProductTileOverride = () => {
  if (tolstoyTileOverrideBound) return;

  waitForElm('tolstoy-carousel').then((carousel) => {
    if (tolstoyTileOverrideBound) return;
    if (!carousel) {
      console.warn('Tolstoy carousel not found');
      return;
    }

    carousel.addEventListener('click', (e) => {
        const tile = e.target.closest('.tolstoy-product-tile');
        if (!tile) return;

        const handle = getTolstoyProductHandle(tile);
        if (!handle) {
          console.error('Could not find product handle for Tolstoy tile', tile);
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }

        openQuickShopModal(handle);
      },
      { capture: true }
    );

    tolstoyTileOverrideBound = true;
  });
};

initTolstoyProductTileOverride();


// accessibility
window.addEventListener('load', function () {
  addAriaLabelsToTolstoySvgs();
  addAriaLabelToQuickAddButtonSvgs();

  const carousel = document.querySelector('tolstoy-carousel');
  if (!carousel) return;

  const observedVideos = new Set();

  function attachVideoListeners(video) {
    if (observedVideos.has(video)) return;
    observedVideos.add(video);

    const container = video.closest('.tolstoy-carousel-video-container');
    const playButton = container?.querySelector('.tolstoy-play-button-container');

    video.addEventListener('play', () => {
      if (playButton) playButton.style.display = 'none';
    });

    video.addEventListener('pause', () => {
      if (playButton) playButton.style.display = '';
    });
  }

  // Initial scan (in case videos are already present)
  carousel.querySelectorAll('video').forEach(attachVideoListeners);

  // Watch for dynamically added videos
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.tagName === 'VIDEO') {
          attachVideoListeners(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('video').forEach(attachVideoListeners);
        }
      });
    });
  });

  observer.observe(carousel, {
    childList: true,
    subtree: true,
  });
});

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function addAriaLabelsToTolstoySvgs() {
  const svgLabelMap = {
    '._playIcon_6kg4i_106': 'Play Tolstoy video',
    '._pauseIcon_6kg4i_110': 'Pause Tolstoy video',
    '._unmuteSvg_1cxli_234': 'Unmute Tolstoy video',
    '._muteSvg_1cxli_224': 'Mute Tolstoy video',
  };

  Object.entries(svgLabelMap).forEach(([selector, label]) => {
    document.querySelectorAll(selector).forEach((svg) => {
      if (!svg.hasAttribute('aria-label')) {
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-label', label);
      }
    });
  });
}

function addAriaLabelToQuickAddButtonSvgs() {
  document.querySelectorAll('.tolstoy-product-tile-button svg').forEach((svg) => {
    if (!svg.hasAttribute('aria-label')) {
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', 'Add to cart');
    }
  });
}

function initLabels() {
  waitForElm(".tolstoy-carousel-controls-container").then((root) => {
    addAriaLabelsToTolstoySvgs();

    const reviewObserver = new MutationObserver(() => {
      addAriaLabelsToTolstoySvgs();
    });

    reviewObserver.observe(root, {
      childList: true,
      subtree: true,
    });
  });
}
